import * as React from "react"
import { useState } from "react"
import { Link, navigate } from "gatsby"
import firebase from "gatsby-plugin-firebase"
import MuiAlert from '@material-ui/lab/Alert';

import { TextField, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, CircularProgress, Snackbar } from "@material-ui/core"

import Header from "../components/Header"

import ImgLogo from "../images/logo.png"
import ImgBoatIcon from "../images/boat-icon.svg"
import ImgBoatIconBlue from "../images/boat-icon-blue.svg"
import ImgBg from "../images/bg.png"
import ImgBg2 from "../images/Flare.png"

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// markup
const IndexPage = () => {
    const [alertDialogOpen, setAlertDialogOpen] = useState(false);
    const [alertDialogTitle, setAlertDialogTitle] = useState("");
    const [alertDialogDesc, setAlertDialogDesc] = useState("");
    const [currentTab, setCurrentTab] = useState(0);

    const [email, setEmail] = useState("")
    const [name, setName] = useState("")
    const [company, setCompany] = useState("")
    const [title, setTitle] = useState("")
    const [fleetSize, setFleetSize] = useState("")
    const [inquiry, setInquiry] = useState("")
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState(false);

    let submitForm = async () => {
        if (!email) {
            setValidated(true);
            return;
        }

        setLoading(true);

        try {
            // let res = await firebase.auth().signInWithEmailAndPassword(email, password);
            // if (res.user)
            //     navigate("/dashboard", { replace: true });
            let res = await fetch(new Request('https://us-central1-uwild-106ed.cloudfunctions.net/submitInquiry'), {
                method: "POST",
                body: JSON.stringify({
                    name, company, email, fleetSize, inquiry
                }),
                headers: new Headers({ 'Content-Type': 'application/json' }),
                credentials: "include",
                mode: "no-cors"
            })

            console.log(res);
            setName("");
            setEmail("");
            setCompany("");
            setFleetSize("");
            setInquiry("");
            setAlertDialogOpen(true);

        } catch (e) {
            console.log(e);
            setSnackbarMessage(e.message);
            setSnackbarOpen(true);
        }
        setLoading(false);
    }

    return (
        <main className="bg-white min-h-screen md:h-screen" style={{ backgroundColor: "rgb(233,233,233)" }}>
            <div className="h-24 flex px-6 md:px-10 py-6 items-center bg-transparent fixed top-0 left-0 right-0 z-30" >
                <img src={ImgLogo} alt="UWILD logo" className="w-20 h-20 mr-12 cursor-pointer" onClick={() => navigate("/")} />
                <div className="flex-grow"></div>
                <a className="hidden md:block text-gray-500 font-medium text-sm uppercase tracking-wide mx-6 md:mx-20 hover:underline" href="/">Home</a>
            </div>

            <div className="flex flex-col md:flex-row md:h-full">

                <div className="w-full md:w-auto relative h-screen bg-contain bg-center bg-no-repeat">
                    <img src={ImgBg2} alt="flare" className="h-screen w-auto" />
                    <div className="absolute bottom-0 left-0 right-0 px-2 py-4">
                        <p className="font-medium text-gray-300 text-sm mb-2">Address</p>
                        <p className="text-xs text-gray-300 font-bold w-full">
                            48 Kings Grove
                            Cranfield, <br />
                            Bedfordshire MK43 1AJ <br />
                            United Kingdom
                        </p>
                    </div>

                </div>
                <div className="w-full flex-grow py-16 px-6 md:px-20 md:h-screen overflow-y-hidden md:overflow-y-scroll text-justify tracking-wide flex-grow flex flex-col justify-start items-start">
                    <h1 className="text-2xl font-medium text-gray-800 mb-2">
                        About
                    </h1>
                    <p className="text-gray-900 text-base mb-2">The <strong className="">UWILD.COM</strong> platform delivers an innovative technology-driven, asset-adaptable and
                        low-footprint approach that leverages new digital technology to provide asset owners the ability to, remotely and in
                        real time, plan and supervise statutory and routine asset integrity inspections, review results and to provide instant
                        confirmation and recommended remediation solutions thereby ensuring:</p>
                    <ol className="text-gray-900 text-base list-decimal list-inside mb-2">
                        <li>Massive cost savings</li>
                        <li>Low footprint/diverless operations that ensure enhanced operational safety</li>
                        <li>End-to-end data integration &amp; information pool </li>
                        <li>Multi-dimensional and multi-location fleet integrity data management</li>
                        <li>Component- or Structure-centric action points</li>
                        <li>Non-intrusive integrity management over the life of the asset</li>
                    </ol>
                    <p className="text-gray-900 text-base mb-2">
                        These and more are achieved through patented technologies in robotics, automation controls and live/real-time defect analyses achievable using a fusion of filtered artificial intelligence
                        algorithms, computation structural analyses and advanced data analytics &amp; security.
                    </p>


                    <p className="text-gray-900 mt-2">For further information please send an inquiry through the form below:</p>
                    <div className="bg-gray-300 px-8 py-2 mb-2 shadow-3xl w-full flex flex-col md:flex-row md:flex-wrap md:items-center rounded-md">
                        <div className="w-full md:w-3/6">
                            <div className="w-full flex flex-col md:flex-row">
                                <div className="w-full md:w-1/2 py-2 px-2">
                                    <TextField
                                        id="name"
                                        size="small"
                                        label="Name"
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        value={name}
                                        error={validated && !name}
                                        helperText={validated && !name ? "Name cannot be empty" : ""}
                                        disabled={loading}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className="w-full md:w-1/2 py-2 px-2">
                                    <TextField
                                        id="email"
                                        size="small"
                                        label="Email Address"
                                        fullWidth
                                        type="email"
                                        variant="outlined"
                                        value={email}
                                        error={validated && !email}
                                        helperText={validated && !email ? "Email cannot be empty" : ""}
                                        disabled={loading}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="w-full flex">
                                <div className="w-full md:w-1/2 py-2 px-2">
                                    <TextField
                                        id="company"
                                        size="small"
                                        label="Company"
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        value={company}
                                        error={validated && !company}
                                        helperText={validated && !company ? "Company cannot be empty" : ""}
                                        disabled={loading}
                                        onChange={(e) => setCompany(e.target.value)}
                                    />
                                </div>
                                <div className="w-full md:w-1/2 py-2 px-2">
                                    <TextField
                                        id="fleet-size"
                                        size="small"
                                        label="Fleet size"
                                        fullWidth
                                        type="number"
                                        variant="outlined"
                                        value={fleetSize}
                                        error={validated && !fleetSize}
                                        helperText={validated && !fleetSize ? "Please provide fleet size" : ""}
                                        disabled={loading}
                                        onChange={(e) => setFleetSize(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="md:flex-grow flex">
                            <div className="w-full py-2 px-2">
                                <TextField
                                    id="inquiry"
                                    size="small"
                                    label="Inquiry"
                                    multiline
                                    rowsMax={6}
                                    rows="4"
                                    fullWidth
                                    type="number"
                                    variant="outlined"
                                    value={inquiry}
                                    error={validated && !inquiry}
                                    helperText={validated && !inquiry ? "Inquiry cannot be empty" : ""}
                                    disabled={loading}
                                    onChange={(e) => setInquiry(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className=" flex">
                            <div className="py-4 shadow-inner shadow-md cursor-pointer hover:shadow-sm uppercase text-sm font-bold 
                text-gray-900 tracking-wide text-center" onClick={() => {
                                    if (loading) return;
                                    submitForm();
                                }}>
                                {loading ? (<CircularProgress size={30} color="white" />) : "Submit"}
                            </div>
                        </div>
                    </div>
                    <div className="w-full py-2 text-center text-xs font-bold text-gray-400 tracking-wide">
                        &copy; {new Date().getFullYear()} UWILD.COM All rights reserved
                    </div>

                </div>

            </div>

            <Dialog
                open={alertDialogOpen}
                onClose={() => setAlertDialogOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"

            >
                <DialogTitle id="alert-dialog-title">Inquiry Sumitted</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your inquiry has been successfully submitted. You will be contacted shortly.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAlertDialogOpen(false)} color="grey">
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </main>
    )
}

export default IndexPage
